import { render } from "./Button.vue?vue&type=template&id=0448868c&scoped=true"
import script from "./Button.vue?vue&type=script&lang=js"
export * from "./Button.vue?vue&type=script&lang=js"

import "./Button.vue?vue&type=style&index=0&id=0448868c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-0448868c"

export default script